export const ONLY_NUMBER_AND_SPCIAL_CHARACTERES = /^[0-9!@#$%^&*()_+\-=[\]{};':"\\|,.<>?]*$/

export const ONLY_NUMBER_AND_LETTERS = /^[a-zA-Z0-9\s]+$/

export const ONLY_NUMBER_AND_LETTERS_URL = /^(https?:\/\/)?(www\.)?[a-zA-Z0-9]+(\.[a-zA-Z0-9]+)+([/a-zA-Z0-9]*)*$/

export const REPLACE_EQUALS_WITH_COLON = /=/g

export const ADD_KEY_DOUBLE_QUOTATION_MARKS = /(\w+):/g

export const ADD_VALUE_DOUBLE_QUOTATION_MARKS = /:([^,}]+)/g

export const PID_VALUE = /-([A-Z]+)(\d*)$/i

export const ONLY_LETTERS = /^(?! )[A-Za-zÀ-ÖØ-öø-ÿ]+(?: [A-Za-zÀ-ÖØ-öø-ÿ]+)*$/
